import type {ReactAction} from '@netx/core/bootstrap';
import {faRecycle} from '@netx/core-icons';
import {canRepurposeCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Repurpose cart assets
 * @param params
 * @returns Action
 */
export const cartActionRepurpose = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-repurpose',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.REPURPOSE),
	enableTest: canRepurposeCurrentCart,
	icon: faRecycle,
	get label() {
		return CART_CURRENT_ACTION_LABELS.REPURPOSE;
	},
	...params,
});

export default cartActionRepurpose;
